//import { useUserData } from "../../../../../context";
import Checkbox from "../../../../../components/commons/Checkbox";

export const DBMTickCellRenderer =()  => {

    //const {user} = useUserData()
    return <Checkbox onChange={()=>{return}} name='' value="" defaultChecked={false}/>

}